<template>
    <div class="modal fade" :id="id" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-sm">
            <div class="modal-content">
                <div class="modal-body p-4">
                    <!-- Close -->
                    <button type="button" class="close p-2" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>

                    <!-- Heading -->
                    <h3 class="text-center">
                        Rückruf vereinbaren
                    </h3>

                    <!-- Errors -->
                    <div class="alert alert-danger form-errors" v-if="Object.keys(errors).length > 0">
                        <ul class="my-0" v-for="errorKey in Object.keys(errors)">
                            <li v-for="error in errors[errorKey]">
                                {{ error }}
                            </li>
                        </ul>
                    </div>

                    <!-- Form -->
                    <div v-if="! isLoading && ! isSuccess">
                        <!-- Info -->
                        <p class="lead text-center">
                            Unser Team wird sich in Kürze bei Ihnen melden!
                        </p>

                        <p>
                            <span class="required">*</span>
                            Pflichtfeld
                        </p>

                        <!-- Name -->
                        <div class="form-group">
                            <label>
                                Vollständiger Name
                                <span class="required">*</span>
                            </label>

                            <input type="text" class="form-control" v-model="name" placeholder="z.B. Thomas Müller" />
                        </div>

                        <!-- Hotel / Company -->
                        <div class="form-group">
                            <label>
                                Hotelname / Firma
                            </label>

                            <input type="text" class="form-control" v-model="subject" placeholder="z.B. Hotel am See" />
                        </div>

                        <!-- Phone -->
                        <div class="form-group">
                            <label>
                                Telefonnummer
                                <span class="required">*</span>
                            </label>

                            <input type="text" class="form-control" v-model="phone" placeholder="Bitte mit Ländervorwahl" />
                        </div>

                        <!-- Submit button -->
                        <button type="button" class="btn btn-primary btn-block btn-lg" @click="submit" :disabled="isLoading">
                            <span v-if="! isLoading">
                                Absenden
                            </span>

                            <i class="fa fa-spinner fa-spin" v-if="isLoading"></i>
                        </button>
                    </div>

                    <!-- Loading -->
                    <div class="text-center p-5" v-if="isLoading">
                        <svg class="loader" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
                            <circle class="internal-circle" cx="60" cy="60" r="30"></circle>
                            <circle class="external-circle" cx="60" cy="60" r="50"></circle>
                        </svg>
                    </div>

                    <!-- Success -->
                    <div class="py-4 text-center" v-if="! isLoading && isSuccess">
                        <i class="fa fa-check fa-2x text-success"></i>

                        <p class="lead">
                            Vielen Dank!
                        </p>

                        <p>
                            Ihr Rückruf ist erfolgreich eingestellt. Wir werden uns in Kürze mit Ihnen in Verbindung setzen.
                        </p>

                        <button type="button" class="btn btn-primary btn-lg mt-3" data-dismiss="modal">
                            Okay
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['id'],
        data() {
            return {
                errors: {},
                isLoading: false,
                isSuccess: false,

                // Submit data
                name: '',
                subject: '',
                phone: '',
            }
        },
        mounted() {},
        computed: {},
        methods: {
            scrollToErrors() {
                setTimeout(() => {
                    $('html,body').stop().animate({
                        scrollTop: $('.form-errors').offset().top - 20
                    }, 500, 'swing');
                }, 200)
            },
            submit() {
                var self = this;

                self.isSuccess = false
                self.isLoading = true
                self.errors = {}

                axios.post(route('api.frontend.partners.recalls.store'), {
                    name: this.name,
                    subject: this.subject,
                    phone: this.phone,
                }).then(function (response) {
                    self.isSuccess = response.data.success
                    self.isLoading = false
                }).catch(function (error) {
                    self.isLoading = false
                    self.errors = error.response.data.errors
                });
            },
        },
        watch: {}
    }
</script>
